<template>
    <div class="card card-blue">
        <div class="card-header">
            <h4 class="card-title">Edit {{challan.number}}
                <span :class="{
                                            'label-info' : challan.status === 'DRAFT' ,
                                            'label-success' : challan.status === 'CONFIRMED' ,
                                            'label-inverse' : challan.status === 'INVOICED'
                                            }"
                      class="label font-weight-bold">
                    <template v-if="challan.status === 'DRAFT'">Draft</template>
                    <template v-if="challan.status === 'CONFIRMED'">Confirmed</template>
                    <template v-if="challan.status === 'INVOICED'">Invoiced</template>
                </span>
            </h4>
        </div>
        <form @submit.prevent="validate">
            <div class="card-body">
                <div class="form-group row" v-if="warehouse.name">
                    <label class="col-sm-2 text-right control-label col-form-label">Warehouse :</label>
                    <div class="col-sm-8">
                        <input class="form-control"
                               disabled
                               v-model="warehouse.name">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 text-right control-label col-form-label">Buyer :</label>
                    <div class="col-sm-8">
                        <multiselect
                                :class="{'is-invalid': submitted && errors.has('buyer')}"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :hide-selected="true"
                                :internal-search="false"
                                :loading="isLoading"
                                :options="partners"
                                :searchable="true"
                                :show-no-results="false"
                                @search-change="searchPartners"
                                class="form-control multiselect-sm"
                                data-vv-as="Buyer"
                                label="buyer"
                                name="buyer"
                                open-direction="bottom"
                                placeholder="Search Buyer"
                                track-by="id"
                                v-model="challan.buyer"
                                v-validate="'required'">
                            <template slot="singleLabel" slot-scope="props">
                                <div class="option__desc">
                                    <div class="option__desc">
                                        {{ props.option.org_name }}
                                    </div>
                                </div>
                            </template>
                            <template slot="option" slot-scope="props">
                                <div class="option__desc">
                                    <div class="option__desc" v-if="props.option">
                                        <h5>{{ props.option.org_name }}</h5>
                                    </div>
                                    <div class="option__desc" v-else>
                                        <h5>Add New</h5>
                                    </div>
                                </div>
                            </template>
                        </multiselect>
                        <div class="invalid-feedback" style="display: block" v-if="submitted && errors.has('buyer')">{{
                            errors.first('buyer') }}
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 text-right control-label col-form-label">Reference :</label>
                    <div class="col-sm-8">
                        <input :class="{'is-invalid': submitted && errors.has('ref')}" class="form-control"
                               data-vv-as="Challan Reference"
                               id="ref2"
                               name="ref"
                               placeholder="Reference"
                               type="text"
                               v-model="challan.ref"
                               v-validate="'required'">
                        <div class="invalid-feedback" style="display: block" v-if="submitted && errors.has('ref')">{{
                            errors.first('ref') }}
                        </div>
                    </div>
                </div>
                <div class="form-group row" v-if="challan.items.length === 0">
                    <label class="col-md-2 text-right control-label col-form-label">Commodity</label>
                    <div class="col-md-4 mt-2">
                        <a class="" data-target="#searchAndSelectCommodityModal" data-toggle="modal"
                           href="javascript:void(0)"><b>Click here to
                            add commodity</b></a>
                    </div>
                </div>
                <div class="form-group row" v-for="(item,i) in challan.items">
                    <label class="col-sm-2 text-right control-label col-form-label">Item {{i+1}} :</label>
                    <div class="col-sm-4">
                        <p class="form-control" style="height: 42px;" v-if="item.good">{{item.good.name}} <span
                                v-if="item.good.code">({{item.good.code}})</span> -
                            {{item.good.variety}}</p>
                    </div>
                    <div class="col-sm-4">
                        <div class="input-group">
                            <input :class="{'is-invalid': submitted && errors.has('quantity'+i)}"
                                   :id="'quantity3'+i"
                                   :name="'quantity'+i"
                                   class="form-control"
                                   data-vv-as="Quantity"
                                   placeholder="Quantity"
                                   step="any"
                                   type="number"
                                   v-model="item.quantity"
                                   v-validate="'required',`between:0,${Number(item.limit)+Number(item.quantity)}`">
                            <input :class="{'is-invalid': submitted && errors.has('quantity'+i)}"
                                   :value="item.unit" class="form-control" disabled
                                   style="max-width: 40px">
                        </div>
                        <div class="invalid-feedback" style="display: block"
                             v-if="submitted && errors.has('quantity'+i)">{{ errors.first('quantity'+i) }}
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <button class="btn btn-success mr-2"
                                data-target="#searchAndSelectCommodityModal" data-toggle="modal" title="Add More Item"
                                type="button" v-if="challan.items.length === 1 || i === challan.items.length-1">
                            <i class="fa fa-plus"/>
                        </button>
                        <button @click="removeItem(i)" class="btn btn-danger" title="Remove This Item"
                                type="button">
                            <i class="fa fa-minus"/>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-footer text-right">
                <div class="button-group">
                    <button class="btn btn-success" type="submit">Confirm</button>
                    <button @click="reset" class="btn btn-secondary" type="button">Reset</button>
                </div>
            </div>
        </form>

        <search-select-commodity :checked-commodity-ids="commodityIds" :pre-commodities="warehouse.inventory"
                                 @commodity-select="setCommodity"></search-select-commodity>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import Multiselect from "vue-multiselect";
    import SearchSelectCommodity from "../../../common/SearchSelectCommodity";

    export default {
        name: "Edit",
        props: ["challanid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {SearchSelectCommodity, Multiselect},
        data() {
            return {
                isLoading: false,
                submitted: false,
                warehouse: {},
                bkp: {},
                challan: {
                    items: []
                },
                invGoods: [],
                partners: [],
                commodityIds: [],
            }
        },
        mounted() {
            this.getChallan();
        },
        methods: {
            async getChallan() {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/challans/${this.challanid}`);
                    this.bkp = data;
                    await this.getWarehouse(data.warehouse.id);
                    this.reset();
                } catch (e) {
                    console.error(e);
                    this.$toastr('error', 'Challan fetch failed', 'Failed');
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async getWarehouse(id) {
                let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${id}`);
                this.warehouse = data;
                for (let i = 0; i < this.warehouse.inventory.length; i++) {
                    let goods = _.filter(this.bkp.items, (itm) => {
                        return itm.express_goods_services_id === this.warehouse.inventory[i].id
                    });
                    console.log('goods', goods)

                    if (goods.length > 0) {
                        this.warehouse.inventory[i].quantity = Number(this.warehouse.inventory[i].quantity) + Number(goods[0].quantity);
                    }
                }
            },
            async validate() {
                this.submitted = true;
                let valid = await this.$validator.validate();

                if (valid) {
                    await this.update();
                }
            },
            async update() {
                try {
                    $(".preloader").fadeIn();

                    let payload = {
                        buyerid: this.challan.buyer.partner_id,
                        warehouseid: this.warehouse.id,
                        items: [],
                        ref: this.challan.ref,
                    };

                    this.challan.items.forEach(item => {
                        console.log('good r', item)
                        payload.items.push({
                            commodity_id: item.good.id,
                            quantity: item.quantity,
                            unit_id: item.good.unit_id
                        });
                    });

                    let {data} = await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/challans/${this.challanid}`, payload);
                    this.$toastr('success', 'Challan updated', 'Success');
                    await this.$router.push({name: 'marketplaceviewchallan', params: {challanid: this.challanid}});
                } catch (e) {
                    console.error(e);
                    this.$toastr('error', 'Challan update failed', 'Failed');
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async searchWareHouses(search) {
                let {data} = await this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/inventory/warehouses`, {
                        params: {
                            search
                        }
                    });
                this.warehouses = data.warehouses;
            },
            filterGoods(searchtxt) {
                this.invGoods = _.filter(this.warehouse.inventory, (inv) => {
                    return inv.name.indexOf(searchtxt) !== -1;
                });
            },
            addItem() {
                this.challan.items.push({
                    good: null,
                    quantity: null,
                    unit: null,
                    limit: 0
                });
            },
            removeItem(i) {
                this.challan.items.splice(i, 1);
                this.commodityIds = this.challan.items.map(row => row.good.id);
            },
            setUnit(item) {
                if (item.good) {
                    let goods = _.filter(this.challan.items, (_item) => {
                        return _item.good.id === item.good.id;
                    });
                    if (goods.length === 1) {
                        item.unit = item.good.unit;
                        item.limit = Number(item.good.quantity);
                    } else {
                        this.$toastr('warning', 'Item already selected', 'Warning!');
                        item.good = null;
                    }
                }
            },
            reset() {
                this.submitted = false;

                this.challan = {
                    buyer: {
                        org_name: this.bkp.buyer,
                        partner_id: this.bkp.org_id,
                    },
                    number: this.bkp.number,
                    status: this.bkp.status,
                    ref: this.bkp.reference,
                    items: []
                }

                this.bkp.items.forEach(item => {
                    let good = _.filter(this.warehouse.inventory, (good) => {
                        return good.id === item.commodity_id
                    });

                    good = good[0];
                    console.log('good', good)

                    this.challan.items.push({
                        good: good,
                        quantity: Number(item.quantity).toFixed(2),
                        unit: item.symbol,
                        limit: good.quantity
                    });
                });
                this.commodityIds = this.challan.items.map(item => item.good.id);
            },
            async searchPartners(searchText) {
                try {
                    this.isLoading = true;
                    let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.partners = reply.data;
                    this.isLoading = false;
                } catch (e) {
                    console.log(e);
                }
            },
            setCommodity(e) {
                let commodities = e;
                commodities.forEach(c=> {
                    let found = this.challan.items.find(row=> row.good.id === c.id);
                    if(!found){
                        this.challan.items.push({
                            good: {
                                commodity_id: c.id,
                                commodity_name: c.name,
                                unit_id: c.unit ? c.unit.id : null,
                                unit_name: c.unit ? c.unit.name : null,
                                unit_symbol: c.unit ? c.unit.symbol : null,
                                ...c
                            },
                            quantity: null,
                            unit: c.unit,
                            limit: Number(c.stock)

                        })
                    }
                })
                this.commodityIds = commodities.map(c=> c.id);
            }
        }
    }
</script>

<style scoped>

</style>
